/** @jsxImportSource @emotion/react */
import { Box, css } from '@mui/material'
import { TOP_NAVBAR_HEIGHT } from '@app/app-constants'
import PropertyNavbar from '@app/components/Property/components/PropertyNavbar'
import React from 'react'

type PropertyLayoutProps = { children?: React.ReactNode }

const PropertyLayout = ({ children }: PropertyLayoutProps) => {
  return (
    <Box>
      <PropertyNavbar />
      <Box css={propertyLayoutContentWrapperStyle}>{children}</Box>
    </Box>
  )
}

export default PropertyLayout

export const propertyLayoutContentWrapperStyle = css`
  height: calc(100vh - ${TOP_NAVBAR_HEIGHT}px);
`
